// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"381":"426e67ca","865":"5d23003e","905":"ec1d6760"}[chunkId] + ".css";
};